import fetch from "auth/FetchInterceptor";

const AuditLogs = {};

const normalizeResponse = (res) => {
  if (!res) return res;
  if (typeof res?.status === "boolean") return res;
  if (typeof res?.success === "boolean") {
    return {
      ...res,
      status: res.success,
      data: res.data,
      message: res.message,
    };
  }
  return res;
};

AuditLogs.get = function (startDate, endDate) {
  return fetch({
    url: "/check/audit-log",
    method: "get",
    params: {
      start_date: startDate,
      end_date: endDate,
    },
  }).then(normalizeResponse);
};

AuditLogs.search = function (startDate, endDate, searchKeyword) {
  return fetch({
    url: "/search/audit-log",
    method: "get",
    params: {
      start_date: startDate,
      end_date: endDate,
      search_keyword: searchKeyword,
    },
  }).then(normalizeResponse);
};

export default AuditLogs;
